import { faDownload, faEdit, faMagnifyingGlass, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import AlertDialogSlide from '../../Common/DeleteDialog'
import { useDispatch, useSelector } from 'react-redux'
import { addChequeType, addProvider, deleteChequeType, deleteProvider, getChequeType, getProvider, searchProvider, updateChequeType, updateProvider } from '../../Redux/Actions/DashOptions'
import { toast } from 'react-toastify'
import Loader from '../../Common/Loader'
import FormAdd from '../../Common/FormAdd'
import Pagination from '../../Common/Pagination'
import { capitalizeFirstLetter } from '../../Utils/helper'
import { debounce } from 'lodash'
import { Circles } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom'

const AddChequeType = () => {
    const dispatch = useDispatch()

    const getChequeListingType = useSelector((state) => state?.DashOptionsSlice?.getChequeTypeData?.data) // get data for listing
    const getListingLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading
    const getSearchedData = useSelector((state) => state?.DashOptionsSlice?.providerSearched?.data)    // get lisitng loading
    const searchedDataLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading

    const { current_page, last_page, } = useSelector((state) => state?.DashOptionsSlice?.listdata || {}); // getting pagination
    const searchPaginationData = useSelector((state) => state?.DashOptionsSlice?.providerSearched || {}); // getting pagination

    const [open, setOpen] = React.useState(false);
    const [openAddForm, setOpenAddForm] = useState(false)
    const [forChequeUpload, setForChequeUpload] = useState(false)
    const [page, setPage] = useState(current_page || 1);
    const [loading, setLoading] = useState(false)
    const [deleteId, setDeleteID] = useState()
    const [itemForEdit, setItemForEdit] = useState()
    const [searchValue, setSearchValue] = useState("")

    const options = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ]
    const handleSubmit = (values, form) => {
        if (!itemForEdit) {
            const formData = new FormData()
            formData.append('name', values.name);
            formData.append('status', values.status);
            if (values.cheque_path && typeof values.cheque_path !== 'string') {
                formData.append('cheque_file', values.cheque_path);
            }
            setLoading(true)
            dispatch(addChequeType(formData)).then((res) => {
                setLoading(false)
                if (res.payload?.data) {
                    setOpenAddForm(false)
                    dispatch(getChequeType({ page: page }))
                    toast.success(res?.payload?.message || 'Successfully added')
                } else {
                    toast.error(res?.payload?.message || 'An error occured')
                }
                form.reset()
            })
        } else {

            const formData = new FormData()
            formData.append('name', values.name);
            formData.append('status', values.status);

            if (values.cheque_path && typeof values.cheque_path !== 'string') {
                formData.append('cheque_file', values.cheque_path);
            }
            setLoading(true)
            dispatch(updateChequeType({ id: itemForEdit.id, payload: formData })).then((res) => {
                setLoading(false)
                if (res.payload?.data) {
                    setOpenAddForm(false)
                    dispatch(getChequeType({ page: page }))
                    toast.success(res?.payload?.message || 'Successfully Updated')
                } else {
                    toast.error(res?.payload?.message || 'An error occured')
                }
                form.reset()
            })
        }

    }

    const validate = (values) => {
        const error = {}
        if (!values.name) {
            error.name = "Required"
        }
        if (!values.cheque_path) {
            error.cheque_path = "Required"
        }
        return error
    }

    const initialValues = useMemo(() => {
        if (itemForEdit) {
            return {
                name: itemForEdit?.name || "",
                cheque_path: itemForEdit?.cheque_file || "",
                status: itemForEdit?.status || "", // You had itemForEdit?.name again
            };
        }
        return {
            name: "",
            cheque_path: "",
            status: "",
        };
    }, [itemForEdit]);

    const handleBack = () => {
        setItemForEdit('')
        setOpenAddForm(false)
    }

    const handleDelete = (selectedID) => {
        setOpen(true)
        setDeleteID(selectedID)
    }

    const handleDeleteByModal = () => {
        dispatch(deleteChequeType(deleteId)).then((res) => {
            if (res?.payload) {
                toast.success(res?.payload?.message)
                setOpen(false);
                dispatch(getChequeType({ page: page }))
            } else {
                toast.error('An error occured')
            }
        })
    }
    const handleFormModal = () => {
        setOpenAddForm(true)
        setForChequeUpload(true)
    }

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleEdit = (selectedItem) => {
        setOpenAddForm(true)
        setForChequeUpload(true)
        setItemForEdit(selectedItem)
    }

    const debouncedSearch = useMemo(() => debounce((query) => {
        if (query.trim() === "") {
            dispatch(searchProvider({ field: "", value: "" }));
            dispatch(getProvider({ page: page }));
            setPage(current_page || 1);
        } else {
            setPage(searchPaginationData?.current_page || 1)
            dispatch(searchProvider({ field: "name", value: query }));
        }
    }, 500), [dispatch]);


    const handleSearch = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        debouncedSearch(value);
    }, [debouncedSearch]);

    const isSearching = useMemo(() => searchValue.trim() !== "", [searchValue]);

    useEffect(() => {
        if (searchValue?.trim() === "") {
            dispatch(getChequeType({ page: page }));
        }
    }, [page, searchValue, dispatch]);

    return (
        <div className="min-h-screen bg-gray-100 p-6">
            {!isSearching && getListingLoading && <Loader />}
            <div className="mx-auto space-y-8">
                {/* FORM CARD */}
                <div className="bg-white shadow-xl rounded-xl p-8">

                    {/* TABLE CARD */}
                    <div className="mt-2">
                        <div className="flex justify-between items-center mb-4">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-800 mb-4">Cheque Type</h3>
                                {/* <div className="relative flex items-center">
                                    <span className="absolute left-3 text-gray-400">
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search Provider..."
                                        onChange={(e) => handleSearch(e)}
                                        className="pl-10 pr-4 py-2 w-full sm:w-80 md:w-96 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    />
                                </div> */}
                            </div>
                            <button
                                onClick={handleFormModal}
                                className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md shadow-md transition duration-300 ease-in-out flex items-center space-x-2"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                </svg>
                                <span>Add Cheque Type</span>
                            </button>
                        </div>

                        <table className="min-w-full divide-y divide-gray-200 text-sm">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-2 py-3 text-left font-semibold text-gray-600 uppercase tracking-wider">Name</th>
                                    <th className="px-2 py-3 text-left font-semibold text-gray-600 uppercase tracking-wider">Status</th>
                                    <th className="px-2 py-3 text-left font-semibold text-gray-600 uppercase tracking-wider">File</th>
                                    <th className="px-6 py-3 text-center font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {searchedDataLoading && isSearching ? (
                                    <tr>
                                        <td colSpan="3" className="text-center py-6 text-gray-500">
                                            <div className="flex justify-center items-center h-40">
                                                <Circles
                                                    height="80"
                                                    width="80"
                                                    color="#2563EB"
                                                    ariaLabel="circles-loading"
                                                    visible={true}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ) : isSearching ? (
                                    getChequeListingType && getChequeListingType?.length > 0 ? (
                                        getChequeListingType.map((item, index) => (
                                            <tr className="hover:bg-gray-50 transition" key={index}>
                                                <td className="px-3 py-3 whitespace-nowrap text-gray-900">{capitalizeFirstLetter(item?.name)}</td>
                                                <td className="px-3 py-3 text-left whitespace-nowrap">
                                                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${item?.status === 'active'
                                                        ? 'bg-green-100 text-green-700'
                                                        : 'bg-red-100 text-red-700'
                                                        }`}>
                                                        {capitalizeFirstLetter(item?.status)}
                                                    </span>
                                                </td>
                                                <td className="px-3 py-3 text-center whitespace-nowrap">
                                                    <div className="flex justify-center space-x-3">
                                                        <button className="text-yellow-500 hover:text-blue-600" onClick={() => handleEdit(item)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                        {/* <button onClick={() => handleDelete(item?.id)} className="text-red-500 hover:text-red-600">
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center py-6 text-gray-500">
                                                No search results found.
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    getChequeListingType && getChequeListingType?.length > 0 ? (
                                        getChequeListingType.map((item, index) => (
                                            <tr className="hover:bg-gray-50 transition" key={index}>
                                                <td className="px-3 py-3 whitespace-nowrap text-gray-900">{capitalizeFirstLetter(item?.name)}</td>
                                                <td className="px-3 py-3 text-left whitespace-nowrap">
                                                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${item?.status === 'active'
                                                        ? 'bg-green-100 text-green-700'
                                                        : 'bg-red-100 text-red-700'
                                                        }`}>
                                                        {capitalizeFirstLetter(item?.status)}
                                                    </span>
                                                </td>
                                                <td className="px-3 py-3 text-start whitespace-nowrap"> {item?.cheque_file ? (
                                                    <a
                                                        href={`${process.env.REACT_APP_LARAVEL_API_URL_DOCUMENT}/${item.cheque_file}`}
                                                        download
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 hover:underline flex items-center gap-2"
                                                    >
                                                        <FontAwesomeIcon icon={faDownload} /> Download
                                                    </a>
                                                ) : (
                                                    "No file"
                                                )}</td>
                                                <td className="px-3 py-3 text-center whitespace-nowrap">
                                                    <div className="flex justify-center space-x-3">
                                                        <button className="text-yellow-500 hover:text-blue-600" onClick={() => handleEdit(item)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                        {/* <button onClick={() => handleDelete(item?.id)} className="text-red-500 hover:text-red-600">
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center py-6 text-gray-500">
                                                No data available.
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>

                        </table>
                        <div className="mt-2 flex justify-end">
                            <Pagination
                                count={!isSearching ? last_page : searchPaginationData?.last_page}  // total pages
                                page={page}         // current page
                                onPageChange={handlePageChange}  // handler
                            />
                        </div>
                    </div>
                </div>

            </div>
            <AlertDialogSlide open={open} setOpen={setOpen} handleDeleteByModal={handleDeleteByModal} />
            <FormAdd validate={validate} initialValues={initialValues} handleBack={handleBack} options={options} handleSubmit={handleSubmit} setOpenAddForm={setOpenAddForm} openAddForm={openAddForm} forChequeUpload={forChequeUpload} />
        </div>
    )
}

export default AddChequeType
